import React from "react";
import { Link } from "react-router-dom";
import ChevronRight from "@material-ui/icons/ChevronRight";
import { categoryImageFit } from "../presentation/imageFit";
import { formatMoney } from "../presentation/money";
import productPlaceholder from "../assets/product-placeholder.png";
import "./GridCategoryCard.css";

// Uses only category data already loaded by the storefront. In particular,
// do not fetch or infer counts from a partial/paginated product list.
export default function GridCategoryCard({ image, name, slug, min_order, description, settings = {}, language }) {
  const ar = language === "arabic";
  const showCaption = !settings.hide_grid_category_name;
  const minimum = Number(min_order);
  const showMinimum = settings.show_prices !== false && !settings.is_menu && Number.isFinite(minimum) && minimum > 0;

  return (
    <Link
      to={`/category/${slug}`}
      aria-label={name}
      className="sf-grid-category"
      dir={ar ? "rtl" : "ltr"}
      style={{ "--sf-category-accent": settings.dark || "#0099cc" }}
    >
      <img
        className="sf-grid-category__image"
        src={image || productPlaceholder}
        alt=""
        loading="lazy"
        style={{ objectFit: image ? categoryImageFit(settings) : "contain" }}
      />
      {showCaption && (
        <div className="sf-grid-category__caption">
          <div className="sf-grid-category__heading">
            <strong>{name}</strong>
            <ChevronRight aria-hidden="true" style={{ transform: ar ? "rotate(180deg)" : undefined }} />
          </div>
          {description && <p className="sf-grid-category__description">{description}</p>}
          {showMinimum && (
            <p className="sf-grid-category__minimum">
              {ar ? "الحد الأدنى للطلب: " : "Min. order: "}
              <bdi>{formatMoney(minimum, { settings, language })}</bdi>
            </p>
          )}
        </div>
      )}
    </Link>
  );
}
